
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[locale]/speed",
      function () {
        return require("private-next-pages/[region]/[locale]/speed.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[locale]/speed"])
      });
    }
  